// Spanish translations for sub-pages
export const subPagesEs = {
  services: {
    eyebrow: 'POS, IT Y TECNOLOGÍA PARA RESTAURANTES',
    title: 'Todo lo que tu restaurante necesita para escalar.',
    intro:
      'Mantén tu restaurante funcionando sin contratiempos con gestión de POS, integraciones de pedidos online, actualizaciones de menú, soporte IT, automatización, analítica y soluciones de crecimiento diseñadas para operaciones modernas.',
    sub:
      'Desde soporte para Toast, Clover y Square hasta pedidos online, automatización con IA, retención de clientes y analítica de rendimiento, Kitxens ayuda a construir una base tecnológica confiable para crecer a largo plazo.',
    primaryCta: { label: 'Auditoría de Crecimiento Gratis' },
    secondaryCta: { label: 'Explorar Servicios' },
    pillarsTitle: 'Un solo socio. Cinco sistemas de crecimiento.',
    pillarsIntro:
      'Desde POS y automatización con IA hasta analítica, visibilidad y crecimiento de ingresos, Kitxens te ayuda a escalar con un ecosistema tecnológico unificado.',
    pillars: [
      { title: 'IT y Sistemas POS', text: 'Despliega, optimiza y soporta las principales tecnologías para restaurantes incluyendo POS, pagos, pedidos online e integraciones.' },
      { title: 'IA y Automatización', text: 'Automatiza tareas repetitivas, mejora tiempos de respuesta y usa agentes de IA para aumentar la eficiencia operativa.' },
      { title: 'Crecimiento de Ingresos', text: 'Identifica oportunidades para aumentar ventas, mejorar la retención y maximizar la rentabilidad con estrategias basadas en datos.' },
      { title: 'Datos y Analítica', text: 'Transforma los datos de tu restaurante en ideas accionables para tomar mejores decisiones operativas y de marketing.' },
      { title: 'Branding Digital', text: 'Fortalece tu presencia online a través de sitios web, optimización de visibilidad, contenido y engagement con clientes.' },
    ],
    benefitsTitle: 'Maximiza el potencial de tu restaurante.',
    benefits: [
      { title: 'Transacciones Ágiles', text: 'Reduce tiempos de espera y mejora la eficiencia de las transacciones, elevando la satisfacción del cliente.' },
      { title: 'Operaciones Más Inteligentes', text: 'Toma decisiones basadas en datos con analítica unificada de pedidos, inventario y personal.' },
      { title: 'Más Visibilidad', text: 'Aparece en Google, Maps y búsqueda con IA con SEO local automatizado y estrategia de contenido.' },
      { title: 'Clientes Fieles', text: 'Activa los datos de clientes con marketing automatizado que convierte visitantes en clientes recurrentes.' },
    ],
    bulletTitle: 'Hablemos de hacer crecer tu restaurante.',
    bullets: [
      'Sistemas tecnológicos para restaurantes.',
      'Automatización con IA para restaurantes.',
      'Visibilidad local y crecimiento SEO.',
      'Analítica de datos y rendimiento.',
      'Estrategias de optimización de ingresos.',
      'Herramientas de eficiencia operativa.',
    ],
  },
  'it-pos-systems': {
    eyebrow: 'IT Y SISTEMAS POS',
    title: 'Tu Departamento de IT y POS en la Nube.',
    intro:
      'Mantén tu restaurante funcionando con sistemas seguros, datos centralizados y soporte experto, reduciendo costos, mejorando la eficiencia y dejando tiempo para enfocarte en tus clientes.',
    sub:
      'Implementamos, gestionamos y damos soporte a Toast, Clover, Square, Lightspeed y las integraciones que los conectan, todo bajo un mismo teléfono, un mismo correo y un mismo equipo.',
    primaryCta: { label: 'Solicita Auditoría Gratis' },
    secondaryCta: { label: 'Ver Todos los Servicios' },
    pillarsTitle: 'Pensado para cada operación de restaurante.',
    pillarsIntro: 'Un stack completo de IT y POS, configurado para tu restaurante y con soporte 24/7.',
    pillars: [
      { title: 'Gestión de POS', text: 'Ingeniería de menú, actualización de ítems, modificadores y "86\u00b4s" sincronizados en todos los canales.' },
      { title: 'Pagos y Hardware', text: 'Lectores de tarjeta, KDS, impresoras y terminales desplegados y reemplazados antes de fallar.' },
      { title: 'Integraciones de Pedidos Online', text: 'DoorDash, Uber Eats, Grubhub y pedidos directos en una sola fuente confiable.' },
      { title: 'Seguridad y Respaldos', text: 'Hardening de red, soporte de cumplimiento PCI y respaldos continuos para cada local.' },
      { title: 'Soporte 24/7', text: 'Un equipo técnico dedicado disponible: un teléfono, un correo, humanos reales.' },
    ],
    benefitsTitle: 'Por qué los restaurantes se cambian a Kitxens.',
    benefits: [
      { title: 'Resolución Más Rápida', text: 'La mayoría de tickets se resuelven remotamente en menos de 15 minutos, con escalada en sitio cuando hace falta.' },
      { title: 'Menores Costos de IT', text: 'Reemplaza múltiples proveedores con una sola suscripción predecible y soporte consolidado.' },
      { title: 'Datos Centralizados', text: 'Ve ventas, nómina y operaciones de todas tus sedes desde un solo dashboard.' },
      { title: 'Equipos Felices', text: 'Cuando la tecnología funciona, tu equipo se enfoca en lo que mejor sabe hacer: hospitalidad.' },
    ],
    bulletTitle: 'Qué incluye.',
    bullets: [
      'Configuración de POS, actualización de menú y gestión de ítems.',
      'Compra, despliegue y garantías de hardware.',
      'Integraciones de pedidos online y delivery.',
      'Monitoreo de red, Wi-Fi y seguridad.',
      'Soporte de cumplimiento PCI y normativo.',
      'Soporte 24/7 por tickets y teléfono.',
    ],
  },
  'restaurant-revenue-growth': {
    eyebrow: 'CRECIMIENTO DE INGRESOS',
    title: 'Aumenta ventas, retención y rentabilidad.',
    intro:
      'Optimiza la eficiencia operativa con herramientas digitales que aumentan los pedidos online, mejoran los flujos de trabajo, reducen tareas manuales y ayudan a retener clientes leales.',
    sub:
      'Combinamos estrategia de precios, ingeniería de menú, marketing automatizado y activación de datos de clientes para impulsar un crecimiento medible en 60-90 días.',
    primaryCta: { label: 'Quiero mi Plan de Ingresos' },
    secondaryCta: { label: 'Ver Todos los Servicios' },
    pillarsTitle: 'Cinco palancas de ingresos.',
    pillarsIntro: 'Sistemas conectados que se potencian: más pedidos, tickets mayores, clientes que vuelven, costos menores.',
    pillars: [
      { title: 'Volumen de Pedidos', text: 'Aumenta pedidos en canales directos, delivery y salón con campañas y visibilidad enfocadas.' },
      { title: 'Ticket Promedio', text: 'Ingeniería de menú, prompts de upsell y combos que aumentan el ticket sin afectar la conversión.' },
      { title: 'Retención', text: 'Flujos automatizados de fidelidad, recuperación y referidos que convierten visitantes en regulares.' },
      { title: 'Optimización de Costos', text: 'Identifica fugas en food cost, ineficiencias de personal e ítems de bajo rendimiento con datos.' },
      { title: 'Rendimiento por Canal', text: 'Optimiza precios y promociones por canal para proteger el margen y crecer las ventas.' },
    ],
    benefitsTitle: 'Resultados reales que ven los restaurantes.',
    benefits: [
      { title: '+15% Ticket Prom.', text: 'Roc \u2018N\u2019 Ramen subió su ticket promedio un 15%, cerca de $120,000/año a plena capacidad.' },
      { title: '+24% Pedidos', text: 'Conceptos multilocación ven 20-30% de incremento en pedidos directos los primeros 90 días.' },
      { title: '92% Retención', text: 'Bases de clientes activadas producen tasas de recompra líderes en la industria.' },
      { title: '−8% Food Cost', text: 'La ingeniería de menú y la analítica de desperdicio reducen el food cost típicamente entre 5-8%.' },
    ],
    bulletTitle: 'Cómo impulsamos los ingresos.',
    bullets: [
      'Auditoría de ingresos y dimensionamiento de oportunidades.',
      'Ingeniería de menú y estrategia de precios.',
      'Campañas automatizadas de email, SMS y fidelidad.',
      'Optimización de pedidos directos para reducir comisiones.',
      'Analítica de mezcla de canales y promociones.',
      'Reportes semanales con un líder de crecimiento dedicado.',
    ],
  },
  'digital-branding': {
    eyebrow: 'BRANDING DIGITAL Y VISIBILIDAD',
    title: 'Que te encuentren. Que te elijan. Que te recuerden.',
    intro:
      'Fortalece la huella digital de tu restaurante con sitios web, optimización de visibilidad, contenido, redes sociales y engagement que atraen más clientes y repiten visitas.',
    sub:
      'Desde tu Perfil de Google y sitio web hasta contenido social y gestión de reputación, construimos una marca digital que convierte búsquedas en mesas ocupadas.',
    primaryCta: { label: 'Aumentar mi Visibilidad' },
    secondaryCta: { label: 'Ver Todos los Servicios' },
    pillarsTitle: 'Un sistema completo de marca digital.',
    pillarsIntro: 'Todo lo que tus clientes ven antes de entrar, diseñado, optimizado y gestionado por nosotros.',
    pillars: [
      { title: 'Sitios Web de Restaurante', text: 'Sitios web de alta conversión con pedidos online, reservas y sincronización de menú.' },
      { title: 'SEO Local y GBP', text: 'Optimización de Perfil de Google, citas y reviews para posicionarte localmente.' },
      { title: 'Contenido y Fotografía', text: 'Fotografía de comida, calendarios de contenido y video en formato corto cada mes.' },
      { title: 'Gestión de Reputación', text: 'Solicitudes automatizadas de reseñas, respuestas y monitoreo de sentimiento.' },
      { title: 'Anuncios Pagos y Sociales', text: 'Campañas en Meta y Google ajustadas para generar pedidos medibles, no solo impresiones.' },
    ],
    benefitsTitle: 'Por qué elegir Kitxens para branding.',
    benefits: [
      { title: 'Más Descubrimiento', text: 'Aparece en Google Maps, búsqueda con IA y redes donde tus clientes te están buscando.' },
      { title: 'Marca Fuerte', text: 'Identidad visual, voz y mensajes consistentes en cada canal y local.' },
      { title: 'Mejores Reseñas', text: 'Calificaciones más altas y más reseñas gracias a flujos automatizados post-visita.' },
      { title: 'Más Pedidos Directos', text: 'Convierte tráfico de búsqueda y redes en pedidos directos sin comisiones.' },
    ],
    bulletTitle: 'Qué incluye.',
    bullets: [
      'Sitio web personalizado con pedidos online.',
      'Optimización de Perfil de Google y SEO local.',
      'Contenido, fotografía y publicaciones sociales mensuales.',
      'Gestión de reputación y automatización de reseñas.',
      'Campañas pagadas en redes sociales y Google.',
      'Identidad de marca, diseño de menú y material impreso.',
    ],
  },
  'ai-and-automation': {
    eyebrow: 'IA Y AUTOMATIZACIÓN',
    title: 'Agentes de IA y flujos pensados para restaurantes.',
    intro:
      'Automatiza tareas repetitivas, mejora los tiempos de respuesta y aprovecha agentes de IA para aumentar la eficiencia en reservas, pedidos, marketing y back-office.',
    sub:
      'Index AI conecta tus datos de clientes, POS, pedidos y canales de marketing en flujos inteligentes que trabajan 24/7, para que tu equipo se enfoque en hospitalidad.',
    primaryCta: { label: 'Automatizar mi Restaurante' },
    secondaryCta: { label: 'Ver Todos los Servicios' },
    pillarsTitle: 'Agentes de IA en toda la operación.',
    pillarsIntro: 'Cinco agentes especializados que se conectan a tu stack y entregan valor desde el día uno.',
    pillars: [
      { title: 'Agente de Recepción', text: 'Contesta llamadas, toma reservas, responde FAQs y captura pedidos perdidos las 24 horas.' },
      { title: 'Respondedor de Reseñas', text: 'Responde a cada reseña en Google, Yelp y TripAdvisor en tu voz de marca en pocos minutos.' },
      { title: 'Agente de Marketing', text: 'Planifica, escribe y agenda campañas de email y SMS basadas en el comportamiento real del cliente.' },
      { title: 'Asistente de Pedidos', text: 'Chat y voz en sitio que recomienda, sube ticket y envía pedidos directo a tu POS.' },
      { title: 'Agente de Insights', text: 'Resumen diario, alertas de anomalías y recomendaciones de crecimiento en tu teléfono.' },
    ],
    benefitsTitle: 'Qué desbloquea la automatización.',
    benefits: [
      { title: 'Horas Cada Semana', text: 'Los dueños ahorran 10-15 horas semanales en tareas repetitivas y comunicaciones.' },
      { title: 'Cero Llamadas Perdidas', text: 'Cada llamada se contesta, califica y convierte en reserva o pedido.' },
      { title: 'Reputación Más Rápida', text: 'El tiempo de respuesta a reseñas cae de días a minutos, mejorando calificaciones y confianza.' },
      { title: 'Más Ingresos', text: 'Upsells inteligentes, flujos de recuperación y recomendaciones aumentan el ticket promedio.' },
    ],
    bulletTitle: 'Cómo desplegamos la IA.',
    bullets: [
      'Llamada de descubrimiento de 30 minutos y auditoría.',
      'Configuración de agentes según tu voz de marca y menú.',
      'Integraciones con POS, pedidos, CRM y plataformas de reseñas.',
      'Lanzamiento en vivo con monitoreo y ajustes semanales.',
      'Reportes mensuales de rendimiento y optimización.',
      'Líder de automatización dedicado y soporte 24/7.',
    ],
  },
  'ai-agents-for-restaurants': {
    eyebrow: 'AGENTES DE IA PARA RESTAURANTES',
    title: 'Un equipo de agentes de IA trabajando 24/7.',
    intro:
      'Agentes especializados que contestan llamadas, toman pedidos, responden reseñas, envían campañas y entregan insights, entrenados con tu voz de marca y conectados a tu stack.',
    sub:
      'Cada agente está configurado para tu concepto, integrado a tu POS y plataformas de pedidos, y supervisado por un equipo humano de Kitxens. Tú mantienes el control mientras la operación corre en piloto automático.',
    primaryCta: { label: 'Desplegar mi Equipo de IA' },
    secondaryCta: { label: 'Ver Todos los Servicios' },
    pillarsTitle: 'Conoce a tu fuerza de trabajo IA.',
    pillarsIntro: 'Agentes listos para usar que entregan valor medible en la primera semana.',
    pillars: [
      { title: 'Agente de Recepción', text: 'Contesta cada llamada, agenda reservas, responde FAQs y captura pedidos perdidos 24/7.' },
      { title: 'Agente de Reseñas', text: 'Responde a reseñas de Google, Yelp y TripAdvisor en tu voz de marca en minutos.' },
      { title: 'Agente de Marketing', text: 'Escribe, agenda y personaliza campañas de email y SMS basadas en datos reales.' },
      { title: 'Agente de Pedidos', text: 'Chat y voz en sitio que recomienda, sube ticket y envía pedidos a tu POS.' },
      { title: 'Agente Concierge', text: 'Gestiona inscripción a fidelidad, gift cards, reservas de grupos y seguimientos post-visita.' },
      { title: 'Agente de Insights', text: 'Resumen diario, alertas de anomalías y recomendaciones de crecimiento.' },
    ],
    benefitsTitle: 'Qué desbloquea un equipo de IA.',
    benefits: [
      { title: '10-15 hs/semana', text: 'Los dueños recuperan tiempo antes invertido en admin y comunicaciones repetitivas.' },
      { title: 'Cero Llamadas Perdidas', text: 'Cada conversación entrante se contesta, califica y convierte.' },
      { title: 'Reputación Más Rápida', text: 'El tiempo de respuesta cae de días a minutos, subiendo calificaciones.' },
      { title: '+12-20% Ingresos', text: 'Upsells, flujos de recuperación y recomendaciones aumentan el ticket de forma medible.' },
    ],
    bulletTitle: 'Cómo desplegamos tu equipo de IA.',
    bullets: [
      'Llamada de descubrimiento y mapeo de casos.',
      'Entrenamiento de agentes en menú, FAQs y voz de marca.',
      'Integraciones a POS, pedidos, CRM y reseñas.',
      'Soft launch con supervisión humana.',
      'Ajuste de rendimiento y reportes semanales.',
      'Líder de automatización dedicado y soporte 24/7.',
    ],
  },
  'index-ai': {
    eyebrow: 'INDEX AI',
    title: 'Aparece donde tus clientes buscan.',
    intro:
      'Index AI es nuestro motor de visibilidad para restaurantes. Optimiza cómo apareces en Google, Maps, búsqueda con IA y descubrimiento social, para que más clientes te encuentren, te elijan y vuelvan.',
    sub:
      'Combinamos SEO local, datos estructurados, optimización para búsqueda con IA y velocidad de reseñas en un programa continuo diseñado para ubicarte en el tope de cada búsqueda relevante.',
    primaryCta: { label: 'Indexar mi Restaurante' },
    secondaryCta: { label: 'Ver Todos los Servicios' },
    pillarsTitle: 'Cómo Index AI te hace descubrible.',
    pillarsIntro: 'Un ciclo continuo de optimización, contenido y señales que se potencia mes a mes.',
    pillars: [
      { title: 'SEO Local', text: 'Citas, schema markup y optimización on-page que te elevan en el local pack de Google.' },
      { title: 'Perfil de Google', text: 'Horarios, fotos, menús y posts siempre frescos: el factor #1 del descubrimiento local.' },
      { title: 'Optimización para IA', text: 'Respuestas estructuradas y contenido afinado para ChatGPT, Perplexity y Google AI Overviews.' },
      { title: 'Velocidad de Reseñas', text: 'Pedidos automatizados de reseñas post-visita que aumentan rating y señales de confianza.' },
      { title: 'Descubrimiento Social', text: 'Video corto, geo-tagging y colaboraciones con creadores para atraer nuevos clientes.' },
      { title: 'Sincronización de Directorios', text: 'Yelp, TripAdvisor, OpenTable, Apple Maps y 40+ directorios sincronizados.' },
    ],
    benefitsTitle: 'El resultado de Index AI.',
    benefits: [
      { title: 'Más Impresiones', text: 'Típicamente 2-3x crecimiento de vistas en Perfil de Google en 90 días.' },
      { title: 'Más Acciones', text: 'Las llamadas, indicaciones y visitas al sitio web crecen junto con las impresiones.' },
      { title: 'Mejores Calificaciones', text: 'El rating promedio sube al crecer el volumen y la velocidad de respuesta a reseñas.' },
      { title: 'Más Ingresos', text: 'Los pedidos directos y reservas crecen a medida que se potencia el descubrimiento.' },
    ],
    bulletTitle: 'Qué incluye Index AI.',
    bullets: [
      'Auditoría y optimización completa de SEO local.',
      'Gestión del Perfil de Google.',
      'Contenido y schema para búsqueda con IA.',
      'Automatización de reseñas y monitoreo de reputación.',
      'Sincronización de listados en 40+ plataformas.',
      'Reportes mensuales de visibilidad y plan de crecimiento.',
    ],
  },
};
